export default "__VITE_ASSET__sR31Z0un__"